export default __webpack_public_path__ + "images/drive-7mhcC.jpeg";